<template>
  <div class="pb-modal" v-bind:class="{ active: showModal }">
    <div class="pb-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      resolve: undefined,
      reject: undefined
    };
  },
  methods: {
    open() {
      this.showModal = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      }).finally(() => {
        this.showModal = false;
        this.resolve = undefined;
        this.reject = undefined;
      });
    },
    close(data, bool = true) {
      if (bool) {
        this.resolve(data);
      } else {
        this.reject(data);
      }
    },
    ok(data) {
      this.close(data, true);
    },
    cancel(data) {
      this.close(data, false);
    }
  }
};
</script>

<style lang="scss" scoped>
.pb-modal {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  
  &.active {
    display: initial;
  }

  .pb-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 15px;
  }
}
</style>